export default __webpack_public_path__ + "static/media/storageUnit1-afterC-480w.c54b83f3.png";